var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mark-content"},[_c('mark-table',{attrs:{"question-index":_vm.questionIndex,"data":_vm.data}}),_c('mark-page',{attrs:{"page":_vm.page,"total":_vm.total},on:{"index-change":_vm.pageIndexChangeHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }